import React from 'react';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import { useFeaturedProperties } from '../../hooks/useFeaturedProperties';
import PropertyCard from '../property/PropertyCard';

const FeaturedProperties = () => {
  const { displayProperties, loading, error, featuredProperties } = useFeaturedProperties(6);
  const isShowingFeatured = featuredProperties.length > 0;
  
  return (
    <section className="py-24 bg-white">
      <div className="container mx-auto px-4">
        <div className="text-center mb-16">
          <span className="text-secondary uppercase tracking-wider font-semibold">Immobili Selezionati</span>
          <h2 className="text-4xl font-monomakh text-primary mt-2">
            {isShowingFeatured ? 'Scopri le Nostre Proposte' : 'I Nostri Ultimi Immobili'}
          </h2>
        </div>
        
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {loading && (
            <div className="text-center py-8 col-span-3">
              <div className="inline-block h-8 w-8 animate-spin rounded-full border-4 border-solid border-primary border-r-transparent"></div>
              <p className="mt-2 text-gray-600">Stiamo cercando gli immobili perfetti per te...</p>
            </div>
          )}

          {!loading && displayProperties.length === 0 && (
            <div className="text-center py-8 col-span-3">
              <p className="text-gray-600">Nessun immobile disponibile al momento.</p>
            </div>
          )}

          {!loading && displayProperties.map((property, index) => (
            <motion.div
              key={property.id}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.5, delay: index * 0.1 }}
            >
              <PropertyCard 
                property={property}
                index={index}
              />
            </motion.div>
          ))}
        </div>
        
        <div className="text-center mt-12">
          <Link
            to="/immobili"
            className="inline-flex items-center bg-primary hover:bg-primary-light text-white font-semibold py-3 px-8 rounded-lg transition-colors group"
          >
            Scopri tutti gli immobili
            <svg className="w-5 h-5 ml-2 transition-transform group-hover:translate-x-1" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M9 5l7 7-7 7" />
            </svg>
          </Link>
        </div>
      </div>
    </section>
  );
};

export default FeaturedProperties;